import Wiifarm from "../img/wiifarm-1.svg";
import Lead from "../img/Page 1.jpg";
import Jaytrends from "../img/Jaytrends Slider-100.jpg";
import Milktheframer from "../img/Artboard 20-100.jpg";

import Wii from "../img/wii.svg";
import Portia from "../img/portia.svg";
import Stylocity from "../img/stylocity.svg";
import Tbh from "../img/TBH.svg";
import Crack from "../img/crack.svg"


//images for wiifarmvest brand 
import img1 from "../img/wiifarm-1.svg"
import img2 from "../img/wiifarm-2.svg"
import img3 from "../img/wiifarm-3.svg"
import img4 from "../img/wiifarm-4.svg"
import img5 from "../img/wiifarm-5.svg"
import img6 from "../img/wiifarm-6.svg"
import img7 from "../img/wiifarm-7.svg"
import img8 from "../img/wiifarm-8.svg"
import img9 from "../img/wiifarm-9.svg"
import img10 from "../img/wiifarm-10.svg"
import img11 from "../img/wiifarm-11.svg"
import img12 from "../img/wiifarm-12.svg"

//images for milktheframer brand 
import milky1 from "../img/milktheframer/milky1.png"
import milky2 from "../img/milktheframer/milky2.png"
import milky3 from "../img/milktheframer/milky3.png"
import milky4 from "../img/milktheframer/milky4.png"
import milky5 from "../img/milktheframer/milky5.png"
import milky6 from "../img/milktheframer/milky6.png"
import milky7 from "../img/milktheframer/milky7.png"
import milky8 from "../img/milktheframer/milky8.png"
import milky9 from "../img/milktheframer/milky9.png"
import milky10 from "../img/milktheframer/milky10.png"
import milky11 from "../img/milktheframer/milky11.png"
import milky12 from "../img/milktheframer/milky12.png"
import milky13 from "../img/milktheframer/milky13.png"


//images for jaytrends brand 
import jay1 from "../img/jaytrends/jay1.png"
import jay2 from "../img/jaytrends/jay2.png"
import jay3 from "../img/jaytrends/jay3.png"
import jay4 from "../img/jaytrends/jay4.png"
import jay5 from "../img/jaytrends/jay5.png"
import jay6 from "../img/jaytrends/jay6.png"
import jay7 from "../img/jaytrends/jay7.png"
import jay8 from "../img/jaytrends/jay8.png"
import jay9 from "../img/jaytrends/jay9.png"


//images for Lead$change brand 
import lead1 from "../img/lead4change/lead1.png"
import lead2 from "../img/lead4change/lead2.png"
import lead3 from "../img/lead4change/lead3.png"
import lead4 from "../img/lead4change/lead4.png"
import lead5 from "../img/lead4change/lead5.png"
import lead6 from "../img/lead4change/lead6.png"
import lead7 from "../img/lead4change/lead7.png"
import lead8 from "../img/lead4change/lead8.png"
import lead9 from "../img/lead4change/lead9.png"



export const brands = [
  {
    id: 0,
    title: "WIIFARM",
    desc: "FULL BRAND DESIGN FOR AGRO-INVEST COMPANY",
    img: Wiifarm,
    link: '/showcase/wiifarmvest'
  },
  {
    id: 1,
    title: "LEAD4CHANGE",
    desc: "FULL BRAND DESIGN FOR AFRICAN NON-PROFIT INITIATIVE",
    img: Lead,
    link: '/showcase/lead4change'
  },
  {
    id: 2,
    title: "JAYTRENDS ",
    desc: "Brand Identity & Advertising for Streetwear/Fashion Brand",
    img: Jaytrends,
    link: '/showcase/jaytrends',
  },
  {
    id: 3,
    title: "MILKTHEFRAMER ",
    desc: "Full Brand Design & Product designs for Framing brand",
    img: Milktheframer,
    link: '/showcase/milktheframer'
  },
];


export const brandlogos = [
  {
    id: 0,
    img: Wii,
    title: "WIIFARM",
  },
  {
    id: 1,
    img: Portia
  },
  {
    id:2,
    img:Stylocity
  },
  {
    id:3,
    img: Tbh
  }, 
  {
    id:4,
    img: Crack
  }


];

export const testimonials = [
  {
    id:0,
    fullname: ' Ayomide Omotosho - The Prime Universal',
    review:'Working with Temi has been absolutely stress-free for myself and the whole team. His skill is exceptional, and he has a great eye for detail. What really stood out to me was his efficiency and his ability to manage his time properly, which is definitely a huge relief for the team. And of course, Temi is a great communicator and is also very responsive to any corrections or concerns we have with any design he makes. And yes, he is a great guy, and I\'d say this anywhere.',
  
  },

  {
    id:1,
    fullname: ' Success Ifeoluwa - Stylocity',
    review:'I have worked with a lot of designers but Temidayo stands out. He is unmatched in terms of his versatility, timeliness, and critical thinking. He was able to assist me with my rebranding, and he did an excellent job. I would keep recommending him to people.',

  },

  {
    id:2,
    fullname: ' Fortune Edwards, CEO The Billion Hub',
    review:'I have been working with Temidayo since 2020, and I can confidently say that he is one of the most talented designers I have ever had the pleasure of collaborating with. His creativity, attention to detail, and ability to capture the essence of my brand in his designs have truly impressed me. He consistently exceeds my expectations and always delivers exceptional work. I highly recommend Temmie to anyone looking for high-quality design services. Thank you for your hard work and dedication to bringing Nochview Solutions and The Billion Hub to life!',

  },
  {
    id:3,
    fullname: ' Victor Bryce - TBLS',
    review:'Working with you was fun even tho I was like an intermediary  between you and the client... Notwithstanding  the pressure amounted you still delivered good designs for  the brand.',

  }

]

export const wiifarmvest = [
  {
    id: 0,
    img: img1
  },
  {
    id: 1,
    img: img2
  },
  {
    id: 2,
    img: img3
  },
  {
    id: 3,
    img: img4
  },
  {
    id: 4,
    img: img5
  },
  {
    id: 5,
    img: img6
  },
  {
    id: 6,
    img: img7
  },
  {
    id: 7,
    img: img8
  },
  {
    id: 8,
    img: img9
  },
  {
    id: 9,
    img: img10
  },
  {
    id: 10,
    img: img11
  },
  {
    id: 11,
    img: img12
  }
]

export const milktheframer = [
  {
    id: 0,
    img: milky1 
  },
  {
    id: 1,
    img: milky2 
  },
  {
    id: 2,
    img: milky3
  },
  {
    id: 3,
    img: milky4 
  },
  {
    id: 4,
    img: milky5 
  },
  {
    id: 5,
    img: milky6 
  },
  {
    id: 6,
    img: milky7 
  },
  {
    id: 7,
    img: milky8 
  },
  {
    id: 8,
    img:milky9 
  },
  {
    id: 9,
    img:milky10 
  },
  {
    id: 10,
    img: milky11 
  },
  {
    id: 11,
    img: milky12 
  },
  {
    id: 12,
    img: milky13 
  }

]


export const jaytrends = [
  {
    id: 0,
    img:jay1 
  },
  {
    id: 1,
    img:jay2 
  },
  {
    id: 2,
    img:jay3
  },
  {
    id: 3,
    img:jay4 
  },
  {
    id: 4,
    img:jay5 
  },
  {
    id: 5,
    img:jay6 
  },
  {
    id: 6,
    img:jay7 
  },
  {
    id: 7,
    img:jay8 
  },
  {
    id: 8,
    img:jay9
  },


]



export const lead = [
  {
    id: 0,
    img:lead1 
  },
  {
    id: 1,
    img:lead2 
  },
  {
    id: 2,
    img:lead3
  },
  {
    id: 3,
    img:lead4 
  },
  {
    id: 4,
    img:lead5 
  },
  {
    id: 5,
    img:lead6 
  },
  {
    id: 6,
    img:lead7 
  },
  {
    id: 7,
    img:lead8 
  },
  {
    id: 8,
    img:lead9
  },


]